import { Cart } from '@/dto'
import { CartDataInitialState } from './types'

const state: CartDataInitialState = {
  cartData: [] as Cart[],
  cartLoading: true,
}
export default state
